export default "__VITE_ASSET___DxdP6sI__ 1600w, __VITE_ASSET__4NiAX8mX__ 800w";